jQuery(document).ready(function($){

    var reviewsSwiper = new Swiper(".swiper-conquesting-reviews", {
        loop: true,
        spaceBetween: 45,
        roundLengths: true,
        speed: 600, // slide transition speed in ms
        autoplay: {
            delay: 2500, // time between slides in ms
            disableOnInteraction: false, // keeps autoplay going after user swipes
            pauseOnMouseEnter: true, // pauses when user hovers
        },
        breakpoints: {
            0: {
                slidesPerView: 1.3,
            },
            768: {
                slidesPerView: 5, // fixed typo (had "4.2t")
            }
        }
    });

    new Swiper('#trust-badge-swiper', {
        loop: true,
        autoplay: {
        delay: 2500,
        disableOnInteraction: false,
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        speed: 600,
    });

});